import { c as _c } from "react/compiler-runtime";
//Third Party
import React from 'react';

// Utils
import { ListingBySlugPartial } from '@utils/imperative-node-queries';
import { concatenateAndReplace } from '@utils/test-helpers';
import { buildListingBreadcrumbs } from '@utils/build-listing-breadcrumbs';

// UI
import { Typography } from '@components/typography';
import { Link } from '@components/link';
type Props = {
  listing: ListingBySlugPartial;
};
export const HeadingAndTitleBar: React.FC<Props> = t0 => {
  const $ = _c(13);
  const {
    listing
  } = t0;
  let t1;
  if ($[0] !== listing.city || $[1] !== listing.regions) {
    t1 = () => {
      const breadcrumbs = buildListingBreadcrumbs(listing.regions, listing.city);
      return <nav className="flex flex-wrap items-center gap-x-1" aria-label="Breadcrumb">{breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1 && !crumb.href;
          return <React.Fragment key={crumb.key}>{crumb.href ? <Link to={crumb.href} className="text-sm text-primary-main font-light hover:text-primary-light">{crumb.name}{", "}</Link> : <span className="text-sm text-primary-main font-light">{crumb.name}{!isLast && ", "}</span>}</React.Fragment>;
        })}<Link to="/" className="text-sm text-primary-main font-light hover:text-primary-light">Vacation Rentals</Link></nav>;
    };
    $[0] = listing.city;
    $[1] = listing.regions;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const renderBreadcrumbs = t1;
  const t2 = `${listing.name}`;
  let t3;
  if ($[3] !== t2) {
    t3 = concatenateAndReplace(t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== listing.name || $[6] !== t3) {
    t4 = <div className="flex items-center"><Typography component="h1" variant="title5" variantL="title4" className="overflow-hidden text-ellipsis -mt-3.5" data-testid={t3}>{listing.name}</Typography></div>;
    $[5] = listing.name;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== renderBreadcrumbs) {
    t5 = <div className="flex">{renderBreadcrumbs()}</div>;
    $[8] = renderBreadcrumbs;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="text-primary-main">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};